<div class="table-container">
  <oui-table
    lineSizing="dense"
    class="oui-table">
    <table
      class="document-table"
      mat-table
      [dataSource]="documents()">
      <ng-container matColumnDef="select">
        <th
          mat-header-cell
          *matHeaderCellDef></th>
        <td
          mat-cell
          *matCellDef="let element">
          <oui-checkbox
            (click)="$event.stopPropagation()"
            (checkedChange)="toggleSelection(element)"
            [checked]="selection.isSelected(element)">
          </oui-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="nom">
        <th
          mat-header-cell
          *matHeaderCellDef>
          Nom
        </th>
        <td
          mat-cell
          *matCellDef="let element">
          <oui-file-item
            class="pointer-events-none"
            type="simplified"
            [showDeleteButton]="false"
            [file]="element.file">
          </oui-file-item>
        </td>
      </ng-container>

      <ng-container matColumnDef="document">
        <th
          mat-header-cell
          *matHeaderCellDef>
          Document
        </th>
        <td
          mat-cell
          *matCellDef="let element">
          {{ element.typeDocumentLabel }}
          @if (element.dateDeReference) {
            <div class="color-on-surface-medium">({{ element.dateDeReference | date: 'shortDate' }})</div>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="depot">
        <th
          mat-header-cell
          *matHeaderCellDef>
          Mise à jour
        </th>
        <td
          mat-cell
          *matCellDef="let element">
          {{ element.dateDeCreation | date: 'shortDate' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="contrat">
        <th
          mat-header-cell
          *matHeaderCellDef>
          N° de contrat
        </th>
        <td
          mat-cell
          *matCellDef="let element">
          {{ element.contratId ?? '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="signature">
        <th
          mat-header-cell
          *matHeaderCellDef>
          Signature
        </th>
        <td
          mat-cell
          *matCellDef="let element">
          <div class="flex-horizontal flex-center gap-8">
            @if (!element.isHandwrittenSignature && element.dateSignature) {
              <oui-icon
                color="secondary"
                [ouiTooltip]="'Par signature électronique'">
                signature
              </oui-icon>
            }
            <div>{{ (element.dateSignature | date: 'shortDate') ?? '-' }}</div>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="expiration">
        <th
          mat-header-cell
          *matHeaderCellDef>
          Expiration
        </th>
        <td
          mat-cell
          *matCellDef="let element">
          {{ (element.dateDeFinValidite | date: 'shortDate') ?? '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="option">
        <th
          mat-header-cell
          *matHeaderCellDef></th>
        <td
          mat-cell
          *matCellDef="let element">
          <div class="flex-horizontal justify-center">
            <oui-menu [menuItems]="getMenuItems(element)">
              <oui-button
                (click)="rowOptionsClicked(element)"
                type="icon"
                color="secondary">
                <oui-icon>more_vert</oui-icon>
              </oui-button>
            </oui-menu>
          </div>
        </td>
      </ng-container>

      <tr
        mat-header-row
        *matHeaderRowDef="documentTableColumns()"></tr>
      <tr
        [class.interactive]="!isAddDocumentSignatureTable()"
        mat-row
        *matRowDef="let row; columns: documentTableColumns()"
        class="cursor-pointer"
        (click)="openFileViewer(row); $event.stopPropagation()"></tr>
    </table>
  </oui-table>
</div>
